import React, { useEffect } from 'react';
import { useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

import useStyles from './Redirecting.style';

type RedirectingProps = {
  resetSignUpStepsState: () => void;
};

const Redirecting: React.FC<RedirectingProps> = ({ resetSignUpStepsState }) => {
  const theme = useTheme();
  const { container, headerText } = useStyles();
  const circularProgressSize = theme.typography.h2.fontSize;

  useEffect(
    () =>
      function cleanup() {
        resetSignUpStepsState();
      },
    [resetSignUpStepsState]
  );

  return (
    <div className={container}>
      <CircularProgress
        size={circularProgressSize}
        title="loading spinner"
        aria-hidden
      />
      {/* TODO: i8n */}
      <Typography variant="h2" className={headerText}>
        Your account was created! Redirecting...
      </Typography>
    </div>
  );
};

export default Redirecting;
